// js -> native interface 요청 함수 모음

//앱 체크하기(웹/앱 체크)
export const getOsEnvironment = async () => {
	const agent = navigator.userAgent.toLowerCase();
	// ANDROID
	if (agent.indexOf('android') !== -1) {
		if (window.eng) {
			return 'AOS_APP';
		} else {
			return 'AOS_WEB';
		}
	}
	// IOS
	if (agent.indexOf('iphone') !== -1 || agent.indexOf('ipad') !== -1 || agent.indexOf('macintosh') !== -1) {
		//COMMNET : IOS 환경에서 크롬앱 사용 시 window.webkit?.messageHandlers가 있는 것으로 보여 푸시함수로 판단
		if (window.webkit && window.webkit?.messageHandlers?.nativeGetPushToken) {
			return 'IOS_APP';
		} else {
			return 'IOS_WEB';
		}
	}
	return 'WEB';
};

// 푸쉬 fcm token 요청 함수
export const getPushToken = async () => {
	const agent = navigator.userAgent.toLowerCase();
	// ANDROID
	if (agent.indexOf('android') !== -1) {
		window.eng?.nativeGetPushToken();
	}
	// IOS
	if (agent.indexOf('iphone') !== -1 || agent.indexOf('ipad') !== -1 || agent.indexOf('macintosh') !== -1) {
		window.webkit?.messageHandlers?.nativeGetPushToken?.postMessage('');
	}
};

// 푸쉬 권한 여부 요청 함수
export const getPushPermissionYn = () => {
	const agent = navigator.userAgent.toLowerCase();
	// ANDROID
	if (agent.indexOf('android') !== -1) {
		window.eng?.nativeCheckPermissionNotification();
	}
	// IOS
	if (agent.indexOf('iphone') !== -1 || agent.indexOf('ipad') !== -1 || agent.indexOf('macintosh') !== -1) {
		window.webkit?.messageHandlers?.nativeCheckPermissionNotification?.postMessage('');
	}
};

// 푸쉬 권한 요청 함수
export const requestPermissionNotification = () => {
	const agent = navigator.userAgent.toLowerCase();
	// ANDROID
	if (agent.indexOf('android') !== -1) {
		window.eng?.nativeRequestPermissionNotification();
	}
	// IOS
	if (agent.indexOf('iphone') !== -1 || agent.indexOf('ipad') !== -1 || agent.indexOf('macintosh') !== -1) {
		window.webkit?.messageHandlers?.nativeRequestPermissionNotification?.postMessage('');
	}
};

// 앱 버전 요청 함수
export const getAppVersion = () => {
	const agent = navigator.userAgent.toLowerCase();
	// ANDROID
	if (agent.indexOf('android') !== -1) {
		window.eng?.nativeGetAppVersion();
	}
	// IOS
	if (agent.indexOf('iphone') !== -1 || agent.indexOf('ipad') !== -1 || agent.indexOf('macintosh') !== -1) {
		window.webkit?.messageHandlers?.nativeGetAppVersion?.postMessage('');
	}
};

// 기기 갤러리 이미지 선택 함수
export const clickedSelectImageButton = (canPushImagesLength) => {
	const agent = navigator.userAgent.toLowerCase();
	// ANDROID
	if (agent.indexOf('android') !== -1) {
		window.eng?.nativeImageSelectButtonClick(canPushImagesLength);
	}
	// IOS(현재 프로젝트에서는 사용하지 않음)
	if (agent.indexOf('iphone') !== -1 || agent.indexOf('ipad') !== -1 || agent.indexOf('macintosh') !== -1) {
		window.webkit?.messageHandlers?.nativeImageSelectButtonClick?.postMessage('');
	}
};
